import React, { FunctionComponent } from 'react';
import { CalculatorStudentLoanStepperStep1, CalculatorStudentLoanStepperStep2 } from './steps';
import { Stepper, StepperStep } from '../../../../shared/general';

interface StepsArray {
  component: FunctionComponent<{ id: number }>;
}

const steps: StepsArray[] = [
  {
    component: CalculatorStudentLoanStepperStep1
  },
  {
    component: CalculatorStudentLoanStepperStep2
  }
];

export const CalculatorStudentLoanStepper = () => {
  return (
    <Stepper previousButtonTexts={['Je studieschuld', 'Je bruto jaarinkomen']}>
      {steps &&
        steps.map((step, key) => (
          <StepperStep id={key} key={key}>
            <step.component id={key} />
          </StepperStep>
        ))}
    </Stepper>
  );
};
